module.exports = __webpack_public_path__ + "static/media/Mct4.34fb4799.jpg";